//COURSES
export const GET_COURSES = "/courses"
export const ADD_NEW_COURSE = "/courses"
export const UPDATE_COURSE = "/courses"
export const DELETE_COURSE = "/courses"

export const GET_COURSES_CATEGORIES_PUBLISHED = "/cursoscategory"
export const GET_COURSES_PUBLISHED = "/profesionales/cursos"
